import { Layout, Menu } from 'antd';
import React from 'react';
import { DashboardOutlined, UserOutlined} from "@ant-design/icons";
import { useHistory } from 'react-router-dom';


const {Sider} = Layout
const menuSidebar = [{
  label: "Dashboard",
  key: '/dashboard-menu',
  icon: <DashboardOutlined style={{fontSize: "20px"}} />,
  children: [
    {
      label: "Movies",
      key: "/table-movies"
    },
    {
      label: "Games",
      key: "/table-games"
    }
  ]},{
  label: "User",
  key: '/user',
  icon: <UserOutlined style={{fontSize: "20px"}}/>,
  children: [{
    label: "Profile",
    key: '/profile',
  }
  ]
  }]

const Sidebar = () => {
    let history = useHistory()
    const HandleMenuSidebar = (props) => {
      history.push(props.key)
    }
    return (
        <Sider className="site-layout-background" width={200}>
           <Menu
            mode="inline"
            theme='dark'
            defaultSelectedKeys={['/dashboard-menu']}
            defaultOpenKeys={['/dashboard-menu']}
            style={{
            height: '100%',
            }}
            items={menuSidebar}
            onClick={HandleMenuSidebar}
            key={menuSidebar.key}
        />                     
        </Sider>
    )
}

export default Sidebar